module.exports = __webpack_public_path__ + "assets/img/experts-3.aa8f172e.png";